import { render } from "./TeammatePopunder.vue?vue&type=template&id=e0152e86&scoped=true"
import script from "./TeammatePopunder.vue?vue&type=script&lang=js"
export * from "./TeammatePopunder.vue?vue&type=script&lang=js"

import "./TeammatePopunder.vue?vue&type=style&index=0&id=e0152e86&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e0152e86"

export default script